<template>
  <div class="general-info">
    <div class="general-info__container">
      <div class="general-info__row">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="general-info__column">
          <div class="general-info__title">
            <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">Новости</h1>
          </div>
          <div class="general-info__row">
            <div class="news__list" v-if="news && news.length">
              <SectionItemNews v-for="newsItem in news" :key="newsItem.id" :item_news="newsItem" />
            </div>
            <p v-else class="news__empty" role="status">
              Пока нет опубликованных новостей.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionItemNews from '@/components/News/SectionItemNews.vue'
import {actionTypesNews} from '@/store/modules/news'
import {mapState} from 'vuex'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

export default {
    name: "AppNews",
    components: {DynamicMenu, SectionItemNews},
    metaInfo() {
      return {
        title: 'Новости | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Новости. Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР.'
          },
          {
            name: 'keywords',
            content: 'Алтайский краевой клинический перинатальный центр'
          }
        ]
      };
    },
    data() {
      return {
        dynamicMenuItems: [],
        linksDepartment: 'about/news',
      }
    },

    computed: {
      ...mapState({
        news: (state) => state.news.news,
      }),
      firstTwoNews() {
        return this.news.slice(0, 2);
      },
      remainingNews() {
        return this.news.slice(2);
      },
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    methods: {
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/about/news');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      }
    },
    mounted() {
      this.$store.dispatch(actionTypesNews.getNews)
          .then(() => {
          })
          .catch((er) => {
            console.log("Ошибка", er);
          });
      this.loadSiblingsForMenu();
    }
  };
</script>


